<div class="comment-item">
    @if (comment.commentTypeDescription) {
        <div class="comment-type">
            <div class="description">
                {{ comment.commentTypeDescription }}
            </div>
            <div class="date">
                {{ comment.createdOn | dateTimeDisplay: true }}
            </div>
        </div>
    }

    @if (comment.value) {
        <div class="comment-content">
            <div [class]="['user-icon', userColor]">{{ comment.initials }}</div>

            <div class="comment-data">
                <div [class]="['comment', comment.commentClass ? comment.commentClass : '']">
                    <div class="username">{{ comment.userName }}</div>
                    <div class="text">
                        {{ showMoreLessButton && showMore ? clippedText : comment.value }}

                        @if (showMoreLessButton) {
                            <div>
                                <span class="link-btn" (click)="onToggleMore()">
                                    Read {{ showMore ? "more" : "less" }}
                                </span>
                            </div>
                        }
                    </div>
                </div>

                <div class="date">{{ comment.createdOn | dateTimeDisplay: true }}</div>
            </div>
        </div>
    }
</div>
